module.exports = __webpack_public_path__ + "img/scan.5baf91f6.png";